import React from "react";
import styles from './Link.module.css'
import classNames from 'classnames'

export const Link = ({onClick, title, className}) => (
    <div className={classNames(styles.link, className)} onClick={onClick}>{title}</div>
)